import { Component, registerComponent } from 'js/component.js';

const componentName = 'static-country-list';

class StaticCountryList extends Component {

    addEventListeners() {
        const previousPage = document.referrer;
        const anchors = document.body.getElementsByTagName('a');
        for (let i = 0; i < anchors.length; i += 1) {
            // modify No Preference link to clear langSite cookie
            if (/No Preference/.test(anchors[i].textContent)) {
                if (anchors[i].getAttribute('listeners') !== '1') {
                    anchors[i].addEventListener('click', (ev) => {
                        ev.preventDefault();
                        this.langSiteCookieUpdate('');
                    });
                    anchors[i].setAttribute('listeners', '1');
                }
            }
            // modify Country Links to open homepage or specific page
            if (anchors[i].classList.contains('country__link')) {
                const selectedHref = anchors[i].getAttribute('href');
                const selectedSite = selectedHref.replace(/.*(\.com)?(\.cn|\/[a-z]{2}-[a-z]{2,3}).*/, '$2');
                if (!anchors[i].getAttribute('listeners')) {
                    anchors[i].addEventListener('click', () => {
                        this.langSiteCookieUpdate(selectedSite === '.cn' ? '/zh-cn.html' : `${selectedSite}.html`); // set langSite cookie
                    });
                    anchors[i].setAttribute('listeners', '1');
                }
                if (/rockwellautomation\.com/.test(previousPage)) {
                    if (anchors[i].getAttribute('listeners') !== '2') {
                        const preferredPage = previousPage.replace(/^(.+\.rockwellautomation\.com)(\.cn\/?|\/[a-z]{2}-[a-z]{2,3})(\/products\/details\.)?([^.]*)(\.html)?$/, `$1${selectedSite}$3$4${/\//.test(selectedSite) ? '.html' : ''}`);
                        if (preferredPage) {
                            anchors[i].addEventListener('click', (ev) => {
                                ev.preventDefault();
                                const preferredPageUrl = new URL(preferredPage);
                                if (preferredPageUrl.origin === window.location.origin) {
                                    fetch(preferredPage, { method: 'HEAD' })
                                        .then(() => { // if it exists, go to previous page in selected site
                                            window.location.href = preferredPage;
                                        })
                                        .catch(() => { // otherwise go to homepage of selected site
                                            window.location.href = `https://${window.location.hostname}${selectedSite}${/\//.test(selectedSite) ? '.html' : ''}`;
                                        });
                                } else {
                                    window.location.href = preferredPage;
                                }
                            });
                            anchors[i].setAttribute('listeners', '2');
                        }
                    }
                }
            }
        }
    }

    langSiteCookieUpdate(value) {
        const expiryDate = new Date();
        expiryDate.setTime(expiryDate.getTime() + (365 * 1000 * 60 * 60 * 24));
        const expiryValue = value === '' ? 'Thu, 01 Jan 1970 00:00:00 UTC' : expiryDate.toUTCString();
        document.cookie = `langSite=${escape(value)};expires=${expiryValue};path=/;secure;domain=.rockwellautomation.com;SameSite=strict`;
    }

    init() {
        this.addEventListeners();
    }
}

registerComponent(`.${componentName}`, StaticCountryList);
